<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper';
import { useQuery } from '@urql/vue';
import { graphql } from '@/gql';
import { breakpoints } from '@glow/shared/lib/breakpoints';
import { LeftArrowIcon, RightArrowIcon } from '@glow/shared/components/icons';
import MasterBlogPost from './MasterBlogPost.vue';

const props = defineProps<{
  masterId: number;
}>();

const { data: queryData, fetching } = useQuery({
  query: graphql(/* GraphQL */ `
    query MasterBlogPostsBlock_MasterQuery($id: Int!) {
      master(id: $id) {
        id
        blogPosts {
          id
          ...MasterBlogPost_BlogPostFragment
        }
      }
    }
  `),
  variables: computed(() => ({
    id: props.masterId,
  })),
});
const blogPosts = toRef(() => queryData.value?.master.blogPosts ?? []);
</script>

<template>
  <div v-if="blogPosts.length" class="page-card py-6 posts">
    <h2 class="px-4 px-sm-6 mb-4 mb-sm-6">Статьи от мастера</h2>
    <AppLoader v-if="fetching" />
    <Swiper
      :modules="[Navigation]"
      :navigation="{
        prevEl: '.slider__prev',
        nextEl: '.slider__next',
      }"
      :breakpoints="{
        [breakpoints['xs']]: {
          spaceBetween: 12,
          slidesPerView: 1.5,
        },
        [breakpoints['sm']]: {
          spaceBetween: 24,
          slidesPerView: 2.25,
        },
        [breakpoints['xl']]: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
      }"
      class="slider px-4 px-sm-6"
    >
      <SwiperSlide v-for="post in blogPosts" :key="post.id" class="h-auto">
        <MasterBlogPost class="h-100" :post="post" />
      </SwiperSlide>
    </Swiper>
    <AppButton
      class="slider__prev shadow"
      variant="link"
      border-radius="full"
      :icon-end="LeftArrowIcon"
    />
    <AppButton
      class="slider__next shadow"
      variant="link"
      border-radius="full"
      :icon-end="RightArrowIcon"
    />
  </div>
</template>

<style scoped lang="scss">
.posts {
  position: relative;

  .swiper-button-disabled {
    display: none;
  }
}

.slider {
  &__prev,
  &__next {
    position: absolute;
    padding: var(--app-spacing-2) !important;
    top: 50% !important;
    z-index: 2;
    color: var(--app-color-black-tertiary);
    background-color: #fff !important;

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  &__prev {
    left: 0;
    margin-left: calc(var(--app-spacing-2) * -1) !important;
  }

  &__next {
    right: 0;
    margin-right: calc(var(--app-spacing-2) * -1) !important;
  }
}
</style>
